export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">

          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="text-2xl leading-none" role="img" aria-label="watermelon">🍉</span>
              <span className="font-heading text-xl text-foreground-900">吃瓜网站</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-md">
              吃瓜网站致力于为广大吃瓜群众提供稳定、快速、安全的访问入口。汇集吃瓜网站线路一、备用入口与最新线路，覆盖吃瓜网站在线观看与首页直达访问，解决访问稳定性问题，让您快速进入吃瓜网站首页。
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-foreground-900 mb-4 text-sm">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '热度排行', href: '#ranking' },
                { label: '主题索引', href: '#index' },
                { label: '精选视频', href: '#media' },
                { label: '网站特色', href: '#features' },
                { label: '常见问答', href: '#faq' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-foreground-900 mb-4 text-sm">合作伙伴</h4>
            <p className="text-sm text-foreground-500">合作伙伴信息正在筹备中，敬请期待。</p>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 吃瓜网站 - 吃瓜网站线路一与吃瓜网站在线入口 | 吃瓜网站大全首页最新线路
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <span>线路一</span>
            <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
            <span>备用入口</span>
            <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
            <span>在线观看</span>
          </div>
        </div>
      </div>
    </footer>
  );
}